/**
 * Title-screen subtitles: one is picked at random each launch. Blunt, lowercase, deadpan, ending
 * with a full stop like the logo. Each fits the 192 px screen in the pixel font (see the test).
 */
export const TITLE_QUIPS: readonly string[] = [
  'you mow the lawn.',
  'mow, baby, mow.',
  'mow lawns.',
  'grass gets cut.',
  "it's a lawnmower.",
  'mow. repeat.',
  'no blade left behind.',
  'one stripe at a time.',
  'lawn and order.',
  'go mow.',
  'keep off the flowers.',
  'short grass. long story.',
  'cut it out.',
  'mow on.',
  'the grass is greener.',
  'it grows back.',
];

/** A quip for this launch. */
export function pickQuip(random: () => number = Math.random): string {
  return TITLE_QUIPS[Math.floor(random() * TITLE_QUIPS.length)] ?? TITLE_QUIPS[0]!;
}
